module.exports = __webpack_public_path__ + "static/media/botaodownload.79db7e85.png";